import * as React from 'react';
import classnames from 'classnames';
import Text from '../text/text';

interface IProps<T> {
    name: string;
    isSelected: boolean;
    disabled?: boolean;
    itemKey: T;
    onClick: (key: T) => void;
}

const SingleSelectOption = <T, >(props: IProps<T>) => {
    const { name, itemKey, isSelected, onClick, disabled = false } = props;

    const handleClick = () => {
        onClick(itemKey);
    };

    return (
        <Text
            tag='div'
            className={classnames('single-select-list__option', {
                'single-select-list__option--selected': isSelected,
                'single-select-list__option--disabled': disabled
            })}
            message={name}
            onClick={!disabled ? handleClick : undefined }
            withEllipsis
        />
    );
};

export { SingleSelectOption };